import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// Fix for Object.groupBy polyfill issue with React
if (typeof Object.prototype.groupBy !== 'undefined') {
  delete Object.prototype.groupBy;
}
if (typeof Array.prototype.groupBy !== 'undefined') {
  delete Array.prototype.groupBy;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
